import { RouteRecordRaw } from 'vue-router';

const trafficRoutes: Array<RouteRecordRaw> = [
  {
    path: 'traffic',
    component: () => import('@/app/traffic/components/traffic-component.vue'),
    name: 'app.traffic',
  },
  {
    path: 'traffic/my-daily-requests',
    component: () =>
      import('@/app/traffic/components/my-daily-requests-component.vue'),
    name: 'app.traffic.my_daily',
  },
  {
    path: 'traffic/archive',
    component: () =>
      import('@/app/traffic/components/archive-traffic-index-component.vue'),
    name: 'app.traffic.archive',
  },
];

export default trafficRoutes;
